import { FC, SVGProps } from 'react';

const CustomFieldNumberIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#7A7A7A',
  size = 16,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.8335 5.33331C5.8335 5.05717 6.05736 4.83331 6.3335 4.83331H9.66683C9.83883 4.83331 9.99876 4.92173 10.0902 5.06739C10.1818 5.21305 10.1919 5.39551 10.1172 5.55045C9.15743 7.54131 8.72696 8.62958 8.52323 10.7152C8.49643 10.9901 8.25183 11.1911 7.97703 11.1642C7.70216 11.1374 7.50116 10.8928 7.52796 10.618C7.72083 8.64365 8.1169 7.47105 8.87636 5.83331H6.8335V6.63189C6.8335 6.90805 6.60964 7.13191 6.3335 7.13191C6.05736 7.13191 5.8335 6.90805 5.8335 6.63189V5.33331Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.49386 2.59792C3.15037 1.89389 4.08519 1.5 5.18875 1.5H10.8119C11.9181 1.5 12.853 1.89369 13.5089 2.59822C14.1611 3.2987 14.5 4.26571 14.5 5.35092V10.6491C14.5 11.734 14.1611 12.701 13.5089 13.4015C12.8529 14.1061 11.9177 14.5 10.8113 14.5H5.18875C4.08253 14.5 3.14745 14.1061 2.49143 13.4016C1.83915 12.7011 1.5 11.7341 1.5 10.6491V5.35092C1.5 4.26501 1.84097 3.29808 2.49386 2.59792ZM3.22522 3.27991C2.77363 3.76419 2.5 4.47272 2.5 5.35092V10.6491C2.5 11.5275 2.77253 12.236 3.22328 12.7201C3.67028 13.2002 4.32958 13.5 5.18875 13.5H10.8113C11.6708 13.5 12.3301 13.2001 12.7769 12.7201C13.2276 12.2361 13.5 11.5276 13.5 10.6491V5.35092C13.5 4.47203 13.2276 3.76357 12.777 3.27962C12.3302 2.79971 11.6711 2.5 10.8119 2.5H5.18875C4.33275 2.5 3.67319 2.79951 3.22522 3.27991Z"
        fill={color}
      />
    </svg>
  );
};

export default CustomFieldNumberIcon;
